import type { RouterOutputs } from "@/trpc";

export type ReviewUploadScan = Pick<
  RouterOutputs["credentials"]["listMyCandidates"][number],
  "scanStatus"
>;

export const BLOCKED_UPLOAD_LABEL = "Blocked by security check";
export const BLOCKED_UPLOAD_DESCRIPTION =
  "This file cannot be previewed or used as a credential document. Upload another copy, or remove this file.";

/** A failed security check takes precedence over the separate OCR outcome. */
export function isReviewUploadBlocked(item: ReviewUploadScan): boolean {
  return item.scanStatus === "quarantined";
}
